import { Weapon } from '../../Weapon.js';
import { FUSED_WEAPONS } from '../../../../../config/constants.js';

/**
 * Storm Lance (Harmonics fusion: Spirit Lance + Arc Needle) — a heavy
 * piercing lance that sheds homing needles as it flies. The lance is Spirit
 * Lance's aimed multi-hit bolt; the needles are Arc Needle's homing darts,
 * spawned from the lance's current position on a fixed interval so a lance
 * crossing the arena leaves a wake of seekers behind it. At max fusion
 * level the needles gain Arc Needle's capstone double-hit.
 */
export class StormLance extends Weapon {
  constructor() {
    super(FUSED_WEAPONS.stormLance);
    this._lances = []; // live lance projectiles still shedding
  }

  update(dt, origin, target, pool) {
    super.update(dt, origin, target, pool);

    this._lances = this._lances.filter((entry) => entry.proj.active);
    for (const entry of this._lances) {
      entry.shedTimer -= dt;
      if (entry.shedTimer <= 0 && target) {
        entry.shedTimer = this.config.shedInterval;
        pool.fire({
          x: entry.proj.x,
          y: entry.proj.y,
          // Launch perpendicular-ish to travel so the wake fans out before
          // homing pulls the needles back in.
          vx: -entry.proj.vy / (entry.proj.speed || 1) * this.config.needleSpeed,
          vy: entry.proj.vx / (entry.proj.speed || 1) * this.config.needleSpeed,
          radius: 1.5,
          damage: this.config.needleDamage + this.level * this.config.needleDamagePerLevel,
          hits: this.level >= this.config.maxLevel ? 2 : 1,
          lifetime: this.config.needleLifetime,
          color: '#8ad1ff',
          homing: true,
          turnRate: this.config.needleTurnRate,
          target,
        });
      }
    }
  }

  fire(origin, target, pool) {
    const dx = target.x - origin.x;
    const dy = target.y - origin.y;
    const dist = Math.hypot(dx, dy);
    if (dist === 0) return;

    const proj = pool.fire({
      x: origin.x,
      y: origin.y,
      vx: (dx / dist) * this.config.projectileSpeed,
      vy: (dy / dist) * this.config.projectileSpeed,
      radius: this.config.projectileRadius,
      damage: this.config.damage + this.level * this.config.damagePerLevel,
      hits: 3,
      hitCooldownDuration: 0.05,
      lifetime: this.config.lifetime,
      color: this.config.color,
    });
    this._lances.push({ proj, shedTimer: this.config.shedInterval });
  }
}
